import { render, staticRenderFns } from "./BaseAttrsItem.vue?vue&type=template&id=5d0a2582&"
import script from "./BaseAttrsItem.vue?vue&type=script&lang=js&"
export * from "./BaseAttrsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/attr/items/BaseAttrsItem.vue"
export default component.exports